import type { BtnIconProps } from '../types/interfaces'

interface UseBtnIconOptions {
  props: BtnIconProps
  onClick: (event: PointerEvent) => void
  onClickClose: (event: Event) => void
}

interface UseBtnIconReturn {
  ariaLabel: ComputedRef<string | undefined>
  handleClick: (event: PointerEvent) => void
  handleClickClose: (event: Event) => void
}

export const useBtnIcon = ({ props, onClick, onClickClose }: UseBtnIconOptions): UseBtnIconReturn => {
  const ariaLabel = computed<string | undefined>(() => props.title || props.tooltipText || undefined)

  const handleClick = (event: PointerEvent): void => {
    onClick(event)
  }

  const handleClickClose = (event: Event): void => {
    onClickClose(event)
  }

  return {
    ariaLabel,
    handleClick,
    handleClickClose,
  }
}
